import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, ViewTransitionInfo } from '@angular/router';

const FORWARD_CLASS = 'vt-forward';
const BACK_CLASS = 'vt-back';

export const handleDetailViewTransition = ({ transition, from, to }: ViewTransitionInfo): void => {
  const router = inject(Router);

  const fromIsDetail = isDetailRoute(from);
  const toIsDetail = isDetailRoute(to);

  if (!fromIsDetail && !toIsDetail) {
    transition.skipTransition();
    return;
  }

  // Skip query-param-only navigations (e.g. tab switches on the same detail page).
  if (getRoutePath(from) === getRoutePath(to)) {
    transition.skipTransition();
    return;
  }

  const isBack = router.currentNavigation()?.trigger === 'popstate' || (fromIsDetail && !toIsDetail);
  const directionClass = isBack ? BACK_CLASS : FORWARD_CLASS;
  const root = document.documentElement;

  root.classList.add(directionClass);
  void transition.finished.finally(() => root.classList.remove(directionClass));
};

const isDetailRoute = (snapshot: ActivatedRouteSnapshot): boolean => {
  let current: ActivatedRouteSnapshot | null = snapshot;
  while (current) {
    if (current.data['isDetail'] === true) return true;
    current = current.firstChild;
  }
  return false;
};

const getRoutePath = (snapshot: ActivatedRouteSnapshot): string => {
  const segments: string[] = [];
  let current: ActivatedRouteSnapshot | null = snapshot;
  while (current) {
    for (const segment of current.url) segments.push(segment.path);
    current = current.firstChild;
  }
  return segments.join('/');
};
